<div *transloco="let transloco">
  <div class="p-5 leading-relaxed text-gray-800">
    <div class="my-5 rounded border-l-4 border-primary bg-primary/10 p-4">
      <h2 class="mb-3 text-xl font-semibold">Wichtige Information</h2>
      <p>Bevor Sie fortfahren, lesen Sie bitte die folgenden Informationen sorgfältig durch.</p>
      <p>
        Mit Ihrer Anmeldung im FARABI-Portal akzeptieren Sie die folgenden Nutzungsbedingungen. Ihre
        Zustimmung erteilen Sie bei der Anmeldung durch „Hiermit akzeptiere ich die
        Nutzungsbedingungen". Alle personenbezogenen Nennungen sind geschlechtsneutral zu verstehen
        und gelten in gleicher Weise für Frauen und Männer.
      </p>
    </div>

    <div class="my-5 text-center text-lg font-bold">
      Islamische Glaubensgemeinschaft in Österreich (IGGÖ)<br />
      Nutzungsbedingungen für FARABI Benutzer
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">I. Vertragsgegenstand, Änderungen</h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 1. Gegenstand der Nutzungsbedingungen</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Die Islamische Glaubensgemeinschaft in Österreich (nachfolgend
          „Diensteanbieter") stellt auf farabi.iggoe.at eine digitale Verwaltungsplattform
          (nachfolgend „FARABI") bereit. Über diese Plattform können ordnungsgemäß angemeldete
          Nutzer sämtliche administrativen Aufgaben im Zusammenhang mit dem islamischen
          Religionsunterricht sowie allgemeine Personalverwaltungsaufgaben digital abwickeln. Dazu
          gehören insbesondere die Kommunikation mit den zuständigen Dienststellen (z. B.
          Fachinspektor, Schulamt, Bildungsamt, Buchhaltung), die Verwaltung und Aktualisierung
          persönlicher Daten sowie die Einreichung, Übermittlung und der Abruf dienstlicher
          Dokumente.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> FARABI dient damit als zentrale Plattform für sämtliche
          organisatorischen, administrativen und personalbezogenen Vorgänge im Rahmen des
          Dienstverhältnisses.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Die vorliegenden Nutzungsbedingungen regeln die Zurverfügungstellung
          der Dienste durch den Diensteanbieter sowie die Nutzung dieser Dienste durch die
          ordnungsgemäß angemeldeten Nutzer.
        </p>

        <p class="mb-3 text-justify">
          <strong>4.</strong> Informationen zum Diensteanbieter erhalten Sie unter:
          <a
            target="_blank"
            href="https://www.derislam.at/impressum"
            class="text-blue-600 hover:underline"
            >https://www.derislam.at/impressum</a
          >
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 2. Änderungen der Nutzungsbedingungen</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Der Diensteanbieter behält sich vor, diese Nutzungsbedingungen
          jederzeit auch innerhalb bestehender Vertragsverhältnisse zu ändern. Über derartige
          Änderungen werden Sie mindestens 30 Kalendertage vor deren geplantem Inkrafttreten
          informiert. Sofern Sie nicht innerhalb dieser Frist widersprechen und die Nutzung nach
          Ablauf der Frist fortsetzen, gelten die Änderungen als wirksam vereinbart. Im Falle eines
          Widerspruchs wird das Vertragsverhältnis zu den bisherigen Bedingungen fortgesetzt. In der
          Änderungsmitteilung wird der Diensteanbieter Sie ausdrücklich auf Ihr Widerspruchsrecht
          und die Folgen hinweisen.
        </p>
      </div>
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">
        II. Anmeldung, Zugangsdaten, Beendigung der Nutzung
      </h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 3. Anmeldeberechtigung</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Die Nutzung von FARABI ist ausschließlich Religionslehrkräften,
          Fachaufsichten für den islamischen Religionsunterricht sowie Mitarbeiterinnen und
          Mitarbeitern des Diensteanbieters vorbehalten.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Voraussetzung für die Nutzung ist die Volljährigkeit, volle
          Geschäftsfähigkeit sowie die Zustimmung zu diesen Nutzungsbedingungen.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 4. Anmeldung auf dem Portal</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Voraussetzung für die Nutzung von FARABI ist die Mitgliedschaft in der
          Islamischen Glaubensgemeinschaft in Österreich.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Nach erfolgreicher Bewerbung und Aufnahme in den Bewerberpool wird
          betreffenden Person bei Verfügbarkeit einer Stelle die Rolle als Religionslehrkraft im
          System zugewiesen.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Die Zugangsdaten werden automatisch an die hinterlegte E-Mailadresse
          übermittelt; die endgültige Freischaltung erfolgt durch die zuständige Fachaufsicht.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 5. Verantwortung für Zugangsdaten</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Zugangsdaten einschließlich Passwort sind vertraulich zu behandeln und
          dürfen Dritten nicht zugänglich gemacht werden.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Bei Verdacht auf Missbrauch oder Kenntnisnahme durch unbefugte Dritte
          sind die Zugangsdaten unverzüglich zu ändern und der Diensteanbieter zu informieren.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Nutzer haften für alle Handlungen, die unter ihren Zugangsdaten
          erfolgen, nach den gesetzlichen Bestimmungen.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 6. Aktualisierung der Daten</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Nutzer sind verpflichtet, ihre persönlichen und dienstlichen Daten
          aktuell zu halten. Änderungen sind unverzüglich im Portal zu aktualisieren oder – falls
          technisch nicht möglich – per E-Mail an den Diensteanbieter mitzuteilen.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 7. Beendigung der Teilnahme</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Mit Beendigung des Dienstverhältnisses endet automatisch die Teilnahme
          an FARABI.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Der Zugang wird gesperrt, sobald die Beendigung wirksam wird.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Daten werden gemäß den gesetzlichen Aufbewahrungspflichten (DSGVO)
          weiter vorgehalten.
        </p>
      </div>
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">III. Dienste und Inhalte auf dem Portal</h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 8. Diensteangebot und Verfügbarkeit</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> FARABI stellt unterschiedliche Verwaltungs- und Informationsdienste
          zur Verfügung. Der konkrete Umfang richtet sich nach den jeweils verfügbaren
          Funktionalitäten.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Die Plattform ermöglicht insbesondere die digitale Abwicklung
          administrativer und personalbezogener Prozesse wie die Übermittlung von Anträgen,
          Meldungen, Formularen oder Bescheinigungen, das Hochladen und Abrufen von Dokumenten sowie
          die Pflege von persönlichen Daten. Die Aufzählung ist nicht abschließend; das Angebot kann
          erweitert werden.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Die Nutzungsbedingungen gelten verbindlich für alle Nutzer.
        </p>

        <p class="mb-3 text-justify">
          <strong>4.</strong> Der Diensteanbieter bemüht sich um hohe technische Verfügbarkeit, kann
          jedoch aufgrund von Wartungen oder unvorhersehbaren Störungen keine ununterbrochene
          Nutzung garantieren.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 9. Digitale Vertragsunterzeichnung</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Mit Zustimmung zu diesen Nutzungsbedingungen erkennen die Nutzer
          ausdrücklich an, dass Verträge und rechtsverbindliche Erklärungen im FARABI-Portal gemäß §
          9 mittels systeminternem TAN-Verfahren digital abgeschlossen werden können.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Dieses Verfahren gilt als einfache elektronische Signatur im Sinne der
          Verordnung (EU) Nr. 910/2014 (eIDAS) und ist rechtlich verbindlich, sofern nicht durch
          Gesetz ausdrücklich eine eigenhändige oder qualifizierte elektronische Unterschrift
          vorgeschrieben ist.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Soweit das Gesetz keine besondere Schriftform verlangt, entfaltet die
          digitale Unterzeichnung dieselbe Rechtswirkung wie eine eigenhändige Unterschrift und ist
          für beide Vertragsparteien verbindlich.
        </p>

        <p class="mb-3 text-justify">
          <strong>4.</strong> Nutzer verpflichten sich, das TAN-Verfahren ausschließlich persönlich
          zu verwenden und Dritten keinen Zugriff zu gewähren. Jede missbräuchliche Verwendung kann
          rechtliche Konsequenzen haben.
        </p>

        <p class="mb-3 text-justify">
          <strong>5.</strong> Mit Zustimmung zu diesen Nutzungsbedingungen erkennen Nutzer
          ausdrücklich an, dass die digitale Unterzeichnung einer eigenhändigen Unterschrift
          gleichgestellt ist.
        </p>

        <p class="mb-3 text-justify">
          <strong>6.</strong> Die digitale Unterzeichnung ersetzt die handschriftliche Unterschrift
          vollständig und entfaltet dieselbe Rechtswirkung, soweit gesetzlich nicht ausdrücklich
          eine qualifizierte elektronische Signatur oder eigenhändige Unterschrift vorgeschrieben
          ist.
        </p>

        <p class="mb-3 text-justify">
          <strong>7.</strong>Dieses Verfahren stellt eine einfache elektronische Signatur im Sinne
          von Art. 3 Z 10 iVm Art. 25 Abs. 1 der Verordnung (EU) Nr. 910/2014 (eIDAS-Verordnung)
          dar. Einer solchen Signatur darf die Rechtswirkung und die Zulässigkeit als Beweismittel
          in Gerichtsverfahren nicht allein deshalb abgesprochen werden, weil sie elektronisch
          erfolgt oder nicht qualifiziert ist.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 10. Änderung von Diensten</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Der Diensteanbieter ist berechtigt, die angebotenen Dienste jederzeit
          anzupassen oder zu erweitern, wobei die berechtigten Interessen der Nutzer berücksichtigt
          werden.
        </p>
      </div>
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">IV. Nutzung des Portals</h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 11. Umfang der Nutzung, Überwachung</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Die Nutzungsberechtigung beschränkt sich auf den Zugang zu FARABI und
          die vertragsgemäße Nutzung der verfügbaren Dienste.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Für die erforderlichen technischen Voraussetzungen ist der Nutzer
          selbst verantwortlich.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Nutzungsaktivitäten können im gesetzlich zulässigen Umfang überwacht
          und protokolliert werden, insbesondere bei Verdacht auf Missbrauch oder Rechtsverstöße.
        </p>

        <p class="mb-3 text-justify">
          <strong>4.</strong> Beim Hochladen von Dateien sind Urheberrechte, Persönlichkeitsrechte
          und die geltenden islamischen Sitten zu wahren. Verboten sind insbesondere rassistische,
          pornografische, menschenverachtende oder beleidigende Inhalte.
        </p>

        <p class="mb-3 text-justify">
          <strong>5.</strong> FARABI ist grundsätzlich rund um die Uhr verfügbar; Wartungsarbeiten
          können jedoch zu Unterbrechungen führen.
        </p>
      </div>
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">V. Verarbeitung personenbezogener Daten</h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 12. Datenschutz</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Personenbezogene Daten werden nur erhoben, gespeichert und
          verarbeitet, soweit dies zur Erfüllung der Dienste erforderlich oder gesetzlich
          vorgeschrieben ist.
        </p>

        <p class="mb-3 text-justify">
          <strong>2.</strong> Eine Weitergabe an Dritte erfolgt nicht, außer bei gesetzlicher
          Verpflichtung oder mit ausdrücklicher Einwilligung.
        </p>

        <p class="mb-3 text-justify">
          <strong>3.</strong> Inhalte des Portals sind Eigentum des Diensteanbieters und
          urheberrechtlich geschützt.
        </p>

        <p class="mb-3 text-justify">
          <strong>4.</strong> Nutzer sind verpflichtet, Datenschutzbestimmungen,
          Geheimhaltungspflichten und dienstliche Verschwiegenheitsverpflichtungen einzuhalten.
        </p>

        <p class="mb-3 text-justify">
          <strong>5.</strong> Sämtliche Inhalte dürfen ausschließlich im Rahmen dienstlicher Zwecke
          genutzt und nicht an unberechtigte Dritte weitergegeben werden.
        </p>
      </div>
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">VI. Haftung</h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 13. Haftungsbeschränkung</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Der Diensteanbieter haftet nur für Schäden, die durch vorsätzliches
          oder grob fahrlässiges Verhalten verursacht werden. Eine weitergehende Haftung ist
          ausgeschlossen, soweit gesetzlich zulässig.
        </p>
      </div>
    </div>

    <div class="mb-6">
      <h2 class="mb-4 mt-8 text-xl font-semibold">VII. Sonstige Bestimmungen</h2>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 14. Schriftformerfordernis</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Soweit nicht anders vorgesehen, sind Erklärungen in Schriftform oder
          per E-Mail an die zuständige Dienststelle zu richten.
        </p>

        <div class="my-4 rounded bg-gray-100 p-4">
          <strong>E-Mail:</strong> farabi&#64;derislam.at | office&#64;derislam.at<br />
          <strong>Adresse:</strong> Bernardgasse 5, 1070 Wien
        </div>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 15. Salvatorische Klausel</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Sollte eine Bestimmung unwirksam sein oder werden, bleibt die
          Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Regelung
          tritt eine solche, die dem wirtschaftlichen Zweck möglichst nahekommt.
        </p>
      </div>

      <h3 class="mb-2 mt-6 text-lg font-medium">§ 16. Gerichtsstand</h3>
      <div class="mb-2 ml-5">
        <p class="mb-3 text-justify">
          <strong>1.</strong> Ausschließlicher Gerichtsstand ist, soweit zulässig, der Sitz des
          Dienstanbieters.
        </p>
      </div>
    </div>

    <div class="mt-8 rounded-lg border-2 border-primary bg-primary/10 p-5 text-center font-bold">
      <h2 class="mb-3 text-xl font-semibold">Schlussbestimmung</h2>
      <p>
        Mit der Betätigung des Buttons „Akzeptieren" erklären Sie, den Inhalt dieser
        Nutzungsbedingungen gelesen, verstanden und akzeptiert zu haben.
      </p>
    </div>
  </div>

  <div class="mt-6 flex items-center justify-center gap-4">
    <p-button
      (click)="this.accepted()"
      [disabled]="this.isPending()"
      severity="primary"
      label="{{ transloco('shared.accept') }}"
      type="button"></p-button>

    <p-button
      (click)="this.declined()"
      [loading]="this.isPending()"
      severity="secondary"
      label="{{ transloco('shared.reject') }}"
      type="button"></p-button>
  </div>
</div>
